import { ReactNode } from 'react'
import { BackButton } from './BackButton'
import { getTopPadding } from '../../../utils/sessionStorage'

export const TopBar = ({ handleBack, children }: { handleBack: () => void; children?: ReactNode }) => {
  return (
    <div style={{ paddingTop: `calc(${getTopPadding()}px + 8px)` }} className='w-full px-6 pb-6 relative z-0'>
      <div className='mr-auto w-max z-1'>
        <BackButton onBack={handleBack} />
      </div>
      {children && (
        <div
          style={{ paddingTop: `calc(${getTopPadding()}px + 8px)` }}
          className='absolute top-0 left-0 pb-6 w-screen -z-10'
        >
          <div className='mx-auto w-max pt-[6px] pr-1'>{children}</div>
        </div>
      )}
    </div>
  )
}
